import { useTranslation } from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { IEvaluationResume } from 'models/evaluation.model'
import { Wrapper, Section, Title, Description, Alert } from './styled'
import Sections from './sections'
import { EvaluationProvider, useEvaluation } from './contexts/Evaluation'
import Buttons from './buttons'

interface IProps {
  data: IEvaluationResume
  setOnEvaluation: (value: boolean) => void
  onEvaluationUpdated: (newEvaluation: IEvaluationResume) => void
}

const EvaluationContent = () => {
  const { t } = useTranslation()
  const { evaluation, previewMode, isSectionsInReviewMode, sections } =
    useEvaluation()
  const translationPrefix = 'lessons.contentBlocks.evaluation'

  return (
    <Wrapper>
      <Section>
        <Title>{evaluation.name}</Title>
        <Description>{evaluation.description}</Description>
        {!isSectionsInReviewMode && !sections.isLoading && (
          <Alert>
            <FontAwesomeIcon icon={faCircleInfo} />
            {t(`${translationPrefix}.alert`)}
          </Alert>
        )}
      </Section>
      <Sections />
      {!(isSectionsInReviewMode || previewMode) && <Buttons />}
    </Wrapper>
  )
}

export const Evaluation = ({
  data,
  setOnEvaluation,
  onEvaluationUpdated,
}: IProps) => {
  return (
    <EvaluationProvider
      evaluation={data}
      setOnEvaluation={setOnEvaluation}
      onEvaluationUpdated={onEvaluationUpdated}
    >
      <EvaluationContent />
    </EvaluationProvider>
  )
}

export default Evaluation
